import { useTranslation } from 'react-i18next';
import { useExtension } from '../../hooks';

type Props = {
  asButton?: boolean;
};

export const ImportCartsCTA = ({ asButton = false }: Props) => {
  const { importCartsFromExtension } = useExtension();

  const { t } = useTranslation();

  if (asButton) {
    return (
      <button
        onClick={importCartsFromExtension}
        className='button-secondary h-12 text-pretty text-center transition-all xs:text-nowrap'
      >
        {t('history.connect_sac_plus_to_extension')}
      </button>
    );
  }

  return (
    <span
      onClick={importCartsFromExtension}
      className='text-200 w-fit min-w-[160px] cursor-pointer text-pretty text-center text-primary underline transition-all hover:text-primary/70'
    >
      {t('history.connect_sac_plus_to_extension')}
    </span>
  );
};
